import UploadedDocuments from "./UploadedDocuments";

export default {
  title: "Components/UploadedDocuments",
  component: UploadedDocuments,
};

const Template = (args) => {
  return (
    <UploadedDocuments {...args} />
  );
};

export const Default = Template.bind({});
Default.args = {
  clientId: '1',
  data: [
    {
        "__typename": "Document",
        "id": "2",
        "name": "UMA stuff",
        "description": "important document about stuff",
        "filename": "uma_doc.txt",
        "updatedAt": "2025-05-22T19:33:43.494Z"
    },
    {
        "__typename": "Document",
        "id": "3",
        "name": "Our Policy Doc",
        "description": "The latest and greatest policy doc",
        "filename": "policy(final).doc",
        "updatedAt": "2025-05-22T20:54:16.976Z"
    }
  ]
};

export const NoResultsWithEditRights = Template.bind({});
NoResultsWithEditRights.args = {
  clientId: '1',
  data: [],
  userCanEdit: true
};

export const NoResultsWithoutEditRights = Template.bind({});
NoResultsWithoutEditRights.args = {
  clientId: '1',
  data: []
};
